export default {
	"order.paymentSuccessful": "payment successful",
	"order.ParameterError": "Parameter error",
	"order.YourPaymentResultHasNotBeenQueriedYet": "Your payment result has not been queried yet",
	"order.lookUpAgain": "look up again",
	"order.payAgain": "pay again",
	"order.RequestingPaymentResults": "Requesting payment results..."
}